import { Link } from "react-router"
import { getProductImgSrc, price } from "#app/utils/misc"
import routes from "#routes"
import LoaderImage from "./loader-image"
import { Icon } from "./ui/icon"
import { WishlistButton } from "#app/components/wishlist/wishlist-button"

export default function HomepageProducts({
	products,
}: {
	products: Array<{
		id: string
		name: string
		price: number
		handle: string
		isUnique: boolean
		images: Array<{ id: string; altText: string | null }>
		variants: Array<{ id: string; price: number }>
	}>
}) {
	return (
		<div className="grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8">
			{products.length > 0 ? (
				products.map((product, index) => (
					<div key={product.id} className="group relative">
						<Link
							className="block"
							to={routes.public.product.route(product.handle)}
						>
							<div className="relative overflow-hidden rounded-lg">
								<LoaderImage
									src={getProductImgSrc(product.images[0].id)}
									alt={product.images[0].altText || `${product.name}`}
									loading={index < 2 ? "eager" : "lazy"}
									decoding={index < 2 ? "sync" : "async"}
									fetchPriority={
										index === 0 ? "high" : index < 2 ? "auto" : "low"
									}
									sizes="(max-width: 640px) 95vw, (max-width: 768px) 50vw, (max-width: 1024px) 33vw, 25vw"
								/>
								{product.isUnique && (
									<div className="absolute bottom-2 right-2 flex items-center gap-1 rounded-full border border-amber-200 bg-amber-50/95 px-2 py-1.5 dark:border-amber-800 dark:bg-amber-950/95">
										<span className="text-[10px] leading-none text-amber-700 dark:text-amber-300">
											Pieza única
										</span>
									</div>
								)}
							</div>
							<h3 className="mt-3 text-sm font-semibold text-gray-700 dark:text-gray-100">
								{product.name}
							</h3>
							<p className="mt-1 text-lg font-medium text-gray-900 dark:text-gray-200">
								{product.variants.length > 0 && (
									<span className="text-xs">desde </span>
								)}
								{product.variants.length > 0
									? price(
											product.variants.reduce(
												(min, variant) =>
													variant.price < min ? variant.price : min,
												product.price,
											),
										)
									: price(product.price)}
							</p>
						</Link>
						<div className="absolute right-2 top-2 z-10 opacity-0 transition-opacity group-hover:opacity-100">
							<WishlistButton productId={product.id} />
						</div>
					</div>
				))
			) : (
				<div className="col-span-full flex items-center gap-2">
					<Icon name="lucide-package-search" className="h-8 w-8" />
					<p>
						Parece que no tenemos productos en este momento. ¡Vuelve a comprobar
						más tarde!
					</p>
				</div>
			)}
		</div>
	)
}
